import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, Redirect } from 'react-router-dom'

import Select, { components } from 'react-select';
import removeImg from './icons/remove.svg'
import moment from 'moment';
import { Modal, OverlayTrigger, Popover, Overlay } from "react-bootstrap";
import uuid from 'react-uuid';

import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'

import { Drawer, Button, Space } from 'antd';

import { setCookie, getCookie } from '../common_component/cookie.js';
import Organization_modal from '../common_component/organization_modal.js';
import Timer_modal from '../common_component/timer_modal.js';


function DealerCollectionList() {
    const [user, setUser] = useState({});
    const [organization_id, setOrganization_id] = useState("")
    const [organization_list, setorganization_list] = useState([]);
    const daterange_picker_ref = useRef();
    const timer = useRef(0)
    const [clock_timer, setClockTimer] = useState(0);
    const [state, setstate] = useState(2);
    const [state1, setstate1] = useState(2);

    const [navtype, setnavtype] = useState("Overview");
    const [Dealer_name, setDealer_name] = useState("");
    const [Collection_details, setCollection_details] = useState(null);
    const [Payment_details, setPayment_details] = useState([]);
    const [Collection_history_details, setCollection_history_details] = useState([]);
    const [open, setOpen] = useState(false);
    const [collection_id, setcollection_id] = useState("");
    const [status, setstatus] = useState("");
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);
    const [page_actions, setpage_actions] = useState([]);

    const timer_interval_ref = useRef();
    const [clockTimerModalShow, setClockTimerModalShow] = useState(false);
    const [state_org, setstate_org] = useState(2);
    const [organization_name, setOrganization_name] = useState("");
    const [OrganizationModalShow, setOrganizationModalShow] = useState(false);
    const [redirect_to_login, setRedirect_to_login] = useState(2);

    const [userTheme, setUserTheme] = useState((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))

    const start = moment().subtract(9, "days").format('YYYY-MM-DD');
    const end = moment().format('YYYY-MM-DD');
    const maxdate = moment().format('YYYY-MM-DD');

    const [startDate, setStartDate] = useState("")
    const [timezone_change,set_timezone_change] = useState("+00:00");
    const [endDate, setEndDate] = useState("")
    const [DealerCollectionList, setDealerCollectionList] = useState([]);

    const [grandTotal, setGrandTotal] = useState(0)
    const [submitButton, SetSubmitButton] = useState(false)
    const [User_role, setUser_role] = useState("")

    const [DenominationModalShow, setDenominationModalShow] = useState(false);
    const [CurrencySymbol, setCurrencySymbol] = useState("");
    const [StatusModalShow, setStatusModalShow] = useState(false);

    const [visibility, setvisibility] = useState(0);
    const [redirect, setredirect] = useState(0);
    const [read, setread] = useState(2);
    const [write, setwrite] = useState(2);

    const [FinalamtArray, setFinalamtArray] = useState([]);
    const [amtArray, setamtArray] = useState([]);

    const [user_name, setuser_name] = useState("");
    const [user_type, setuser_type] = useState("");
    const [dealer_organization_id, setdealer_organization_id] = useState("");
    const [user_id, setuser_id] = useState("");


    const overlay_ref = useRef()

    const search_length = 2;

    const days_limit = 30;

    var page_name = "dealer-collection-list";

    let dropdownStyleDark = {
        option: (provided, state) => ({
            ...provided,
            color: '#dddddf',
            backgroundColor: state.isSelected ? provided.backgroundColor : state.isFocused ? '#5f5f8d' : provided.backgroundColor,
        }),
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
            borderColor: "#4c4c71"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        menu: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
        })
    }

    const onClose = () => {
        setOpen(false);
        setCollection_history_details([]);
        setCurrencySymbol("");
        setCollection_details(null);
    };

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    useEffect(() => {
        if (getCookie("access_token") != "") {
            if (getCookie("organization_id") != "") {
                setOrganization_id(getCookie("organization_id"));
            }
            else {
                var object = {};
                object.page_name = page_name;
                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "token": getCookie("access_token"),
                        "Accept": "*/*"
                    }
                }

                axios.post(`${process.env.REACT_APP_SERVER_URL}/show-organization`, object, headers).then((res) => {
                    if (res.data.length == 1) {
                        setCookie('organization_id', res.data[0].organization_id, 1, true);
                        setOrganization_id(res.data[0].organization_id)
                    }
                    else {
                        setstate_org(1);
                        setorganization_list(res.data);
                        setOrganizationModalShow(true);
                    }
                })
            }
        }
        else {
            setRedirect_to_login(1);
        }
    }, [])

    useEffect(() => {
        setCookie("lastpage", window.location.href, 1, false)
        const validateJWT = () => {

            if (getCookie("access_token") != "") {
                var object = {};
                object.token = getCookie("access_token");

                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "*/*"
                    }
                }
                axios.post(`${process.env.REACT_APP_SERVER_URL}/get-user`, object, headers).then((res) => {

                    if (res.data.operation == "success") {
                        var user_object = {};
                        user_object.email = res.data.email;
                        user_object.name = res.data.name;
                        user_object.img = res.data.img;
                        setUser(user_object)
                    }
                    else {
                        setRedirect_to_login(1);
                    }
                })
                    .catch(function (error) {
                        setRedirect_to_login(1);
                    });

                object.organization_id = organization_id;
                axios.post(`${process.env.REACT_APP_SERVER_URL}/audience-info`, object, headers).then((res) => {

                    if (res.data.operation == "success") {
                        var token = res.data.audience_license;
                        if (res.data.organization_flag == 0) {
                            setstate_org(3);
                            setOrganization_name(res.data.organization_name);
                            setOrganizationModalShow(true);
                        }
                        else {
                            setuser_name(res.data.user_type.name);
                            setuser_type(res.data.user_type.type);
                            setdealer_organization_id(res.data.user_type.organization_id);
                            setuser_id(res.data.user_type.id);
                            var path = window.location.pathname;
                            path = path.replace(/\/$/, "");
                            path = decodeURIComponent(path);
                            var original_url = path.split("/")[1]
                            let index = 0;
                            let temp = -1;
                            
                            for (let i = 0; i < res.data.user_access.access.length; i++) {
                                if (temp == 1) break;
                                let component = res.data.user_access.access[i].inside_components;
                                for (let j = 0; j < component.length; j++) {
                                    if (temp == 1) break;
                                    if (component[j].hasOwnProperty(original_url)) {
                                        index = i;
                                        if (component[j][original_url] == 1 && res.data.user_access.access[index].visibility == 1) {
                                            temp = 1;
                                            setvisibility(1);
                                            setread(component[j]["read"])
                                            setwrite(component[j]["write"])
                                            // setwrite(0)
                                            // break;
                                        }
                                        else {
                                            setredirect(1);
                                        }
                                    }
                                    else if (component[j].hasOwnProperty("key")) {
                                        let sub_inside_components = component[j].inside_components
                                        for (let k = 0; k < sub_inside_components.length; k++) {
                                            if (sub_inside_components[k].hasOwnProperty(original_url)) {
                                                index = i
                                                if (sub_inside_components[k][original_url] == 1 && res.data.user_access.access[index].visibility == 1 && component[j].visibility == 1) {
                                                    temp = 1;
                                                    setvisibility(1);
                                                    setread(sub_inside_components[k]["read"])
                                                    setwrite(sub_inside_components[k]["write"])
                                                    // setwrite(0)
                                                    break;

                                                }
                                                else {
                                                    setredirect(1);
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        temp = 2;
                                    }
                                }
                            }

                            if (temp == 2) {
                                setredirect(1);
                            }

                        }
                        if (!token.includes("ufhdsupw29fher") || !token.includes("pdbwu27dh6schs") || !token.includes("0dh27agiqbcrwi")) {
                            setCookie('access_token', res.data.audience_license, 1, true)
                            timer.current = process.env.REACT_APP_JWT_EXPIRY;
                        }
                        else {
                            timer.current = res.data.audience_count;
                        }
                    }
                    else {
                        setRedirect_to_login(1);
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                        setRedirect_to_login(1);
                    });
            }
            else {
                setRedirect_to_login(1);
            }
        }
        organization_id != "" && validateJWT();
    }, [organization_id])

    useEffect(() => {
        timer_interval_ref.current = setInterval(() => {
            // console.log(timer)

            timer.current = timer.current - 1
            if (timer.current > 0 && timer.current < process.env.REACT_APP_JWT_EXPIRY_NOTICE) {
                if (!clockTimerModalShow) {
                    setClockTimer(process.env.REACT_APP_JWT_EXPIRY_NOTICE)
                    setClockTimerModalShow(true)
                }
            }
        }, 1000);
        
        return () => {clearInterval(timer_interval_ref)};
    }, []);

    async function getUserRole() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-user-role`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            let user_details = body.data[0].user_details;
            setUser_role(body.data[0].user_role);
            if (body.data[0].user_role === "DSO") {
                //setSelectedDsoUser({ label: user_details.name + " - " + user_details.user_id, value: user_details.user_id });
            }
        }
        else {
            throw "transaction series api list error"
        }
    }
    async function getCollectionHistoryDetails(id) {
        //setstate(2);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-dealer-collection-entry-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name,"id":id,"organization_id":organization_id,"dealer_organization_id": dealer_organization_id}), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setCollection_history_details(body.data);
        }
    }
    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email,"page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") 
        {
            if(body.data.length>0)
            {
                if(body.data[0].timezone_value != "" && body.data[0].timezone_value != null)
                {
                    let timezone = body.data[0].timezone_value;
                    set_timezone_change(timezone);
                    setStartDate(moment().utcOffset(timezone).subtract(6,"days").format("YYYY-MM-DD"));
                    setEndDate(moment().utcOffset(timezone).format("YYYY-MM-DD"));
                }
                else
                {
                    setStartDate(moment.utc().subtract(6,"days").format("YYYY-MM-DD"));
                    setEndDate(moment.utc().format("YYYY-MM-DD"));
                }
            }
            else
            {
                setStartDate(moment.utc().subtract(6,"days").format("YYYY-MM-DD"));
                setEndDate(moment.utc().format("YYYY-MM-DD"));
            }
        }
        else {
            throw "timezone api error"
        }
    }

    async function getCollectionEntry(start,end) {
        setstate(2);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-dealer-collection-summary`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name,"flag":"collection_list","user_id":user_id,"start_date":start,"end_date":end,"organization_id": organization_id,"dealer_organization_id": dealer_organization_id}), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            if(body.data.length>0)
            {
                for(let i=0;i<body.data.length;i++)
                { 
                    let temp=body.data[i].payment_details.map(a=>{return {...a}});
                    let temp1=[];
                    if(body.data[i].collection_entry_flag==="dealer-collection-entry")
                    {
                        if(temp.filter(option => option.payment_method==="Cheque")[0].payment_info.length>0)
                        {
                            temp1.push("Cheque");
                        }
                        if(temp.filter(option => option.payment_method==="Cash")[0].payment_info.length>0)
                        {
                            temp1.push("Cash");
                        }
                        if(temp.filter(option => option.payment_method==="Bank Transaction")[0].payment_info.length>0)
                        {
                            temp1.push("Bank Transaction");
                        }
                    }
                    else
                    {
                        if(temp.filter(option => option.payment_method==="Cheque")[0].payment_info.length>0)
                        {
                            temp1.push("Cheque");
                        }
                    }
                    body.data[i].payment_mode=temp1.toString();
                }
                setDealerCollectionList(body.data);
                setstate(1);
            }
            else
            {
                setstate(4);
            }
        }
        else 
        {
            throw "transaction series api list error"
        }
    }

    useEffect(() => {

        if((startDate!="") && (endDate!=""))
        {
            getCollectionEntry(startDate,endDate);
        }

    }, [startDate,endDate])

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getTimezoneInformation();
            let p2 = getUserRole();
            Promise.all([p1,p2])
                .then(async () => {
                    //setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    //setstate(3)
                    console.log(err)
                    swal("Oops!", err, "error")
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        let id = setInterval(() => {
            setUserTheme((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))
        }, 10)

        return () => {
            clearInterval(id)
        }
    }, [])

    const setUpDrawer = (id) => {
        let tempData = DealerCollectionList.find(option => option.unique_id == id)
        setOpen(true);
        setnavtype("Overview");
        //console.log(tempData);
        setCollection_details(tempData);
        setCurrencySymbol(tempData.currency.Currency_symbol);
        setPayment_details(tempData.payment_details);
        getCollectionHistoryDetails(id);
    }

    const Set_Denomination = (val) => {
        setFinalamtArray(val);
        setDenominationModalShow(true);
    }

    const updateStatus = (id) => {
        for (let i = 0; i < DealerCollectionList.length; i++) {
            if (id == DealerCollectionList[i].unique_id) {
                setcollection_id(id);
                setstatus(DealerCollectionList[i].log_status);
                setStatusModalShow(true);
            }
        }
    }

    const submitStatus = (e) => {
        e.preventDefault();

        var values = { "id":collection_id,"save_flag":true,"page_name":page_name,"organization_id":organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-status-collection-entry`, values, headers).then((res) => {
            setMainSubmitButtonState(false) 
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Collection cancelled successfully!", "success").then((value) => {
                    window.location.reload();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    return (
        <>
            {
                (redirect == 1 || (read == 0 && write == 0)) ?
                    <>
                        <Redirect to={{
                            pathname: "/unauthorized",
                        }}
                        />
                    </> :
                    null
            }
            {
                redirect_to_login == 0 ? null : (redirect_to_login == 1 ? <>
                    <Redirect to={{ pathname: "/login" }} />
                </> : null)
            }

            <div className="d-flex flex-column flex-column-fluid">
                <div className="app-toolbar py-3 py-lg-6" id="kt_app_toolbar">
                    <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Dealer Collection List</h1>
                        {(startDate!=="" && endDate!="")&&
                        <div className="d-flex align-items-center gap-5 mx-5 my-2">
                            <DateRangePickerComponent
                                ref={daterange_picker_ref}
                                allowEdit={false}
                                focus={(e)=>{
                                    daterange_picker_ref.current.show()
                                }}
                                delayUpdate={true}
                                change={(e)=>{
                                    setStartDate(e.startDate);
                                    setEndDate(e.endDate);
                                }}
                                startDate={startDate}
                                endDate={endDate}
                            />
                        </div>}
                    </div>
                </div>
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    <div id="kt_app_content_container" className="app-container container-xxl">
                        <div className="card mb-5 mb-xl-8">
                            <div className="card-header border-0 pt-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold fs-3 mb-1">Collection List</span>
                                    <span className="text-muted mt-1 fw-semibold fs-7">Over {DealerCollectionList.length} Collection</span>
                                </h3>
                            </div>
                            <div className="card-body py-3">
                            {DealerCollectionList.length>0 ?
                                <div className="table-responsive" style={{
                                    "min-height": "200px"
                                }}>
                                    <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                        <thead>
                                            <tr className="fw-bold text-muted">
                                                {/* <th className="w-25px">
                                                    <div className="form-check form-check-sm form-check-custom form-check-solid">
                                                        <input className="form-check-input" type="checkbox" value="1" data-kt-check="true" data-kt-check-target=".widget-13-check"/>
                                                    </div>
                                                </th> */}
                                                <th className="min-w-150px">Id</th>
                                                <th className="min-w-120px">Type</th>
                                                <th className="min-w-140px">Date</th>
                                                {/* <th className="min-w-120px">Dso User</th> */}
                                                <th className="min-w-120px">Dealer</th>
                                                <th className="min-w-120px">Payment Mode</th>
                                                <th className="min-w-120px">Status</th>
                                                <th className="min-w-100px text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            DealerCollectionList.map((obj3, indx3) => {
                                                return (
                                                    <>
                                                    <tr>
                                                        {/* <td>
                                                            <div className="form-check form-check-sm form-check-custom form-check-solid">
                                                                <input className="form-check-input widget-13-check" type="checkbox" value="1"/>
                                                            </div>
                                                        </td> */}
                                                        <td>
                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.dcr_number!=undefined?<>{obj3.dcr_number}</>:<>{obj3.pdcr_number}</>}</a>
                                                            <span className="text-muted fw-semibold text-muted d-block fs-7">Branch: {obj3.branch_name}</span>
                                                        </td>
                                                        <td>
                                                        {obj3.dcr_number!=undefined?
                                                            <span className="badge badge-light-info">DCR</span>
                                                            :
                                                            <span className="badge badge-light-info">PDCR</span>
                                                        }    
                                                        </td> 
                                                        <td>
                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.dcr_date!=undefined?<>{moment(obj3.dcr_date).format("ll")}</>:<>{moment(obj3.pdcr_date).format("ll")}</>}</a>
                                                            {/* <span className="text-muted fw-semibold text-muted d-block fs-7">Code: PH</span> */}
                                                        </td>
                                                        {/* <td>
                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.dso_name}</a>
                                                            <span className="text-muted fw-semibold text-muted d-block fs-7"></span>
                                                        </td> */}
                                                        <td>
                                                            <a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.dealer_display_name}</a>
                                                            <span className="text-muted fw-semibold text-muted d-block fs-7"></span>
                                                        </td>
                                                        
                                                        <td className="text-dark fw-bold text-hover-primary fs-6">
                                                            <span className="badge badge-light-primary">
                                                            {obj3.payment_mode}
                                                            </span>                            
                                                        </td>  
                                                        <td>
                                                        {obj3.log_status==="PENDING_APPROVAL" ?
                                                            <span className="badge badge-light-warning">Pending</span>
                                                            :
                                                            obj3.log_status==="DRAFT" ?
                                                            <span className="badge badge-secondary">Draft</span>
                                                            :
                                                            obj3.log_status==="DRAFT" ?
                                                            <span className="badge badge-secondary">Draft</span>
                                                            :
                                                            obj3.log_status==="cancelled" ?
                                                            <span className="badge badge-danger">Cancelled</span>
                                                            :
                                                            <span className="badge badge-success">{obj3.log_status}</span>
                                                        }    
                                                        </td>             
                                                        <td className="text-end">
                                                            <div className="dropdown">
                                                                <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <i className="fas fa-bars px-0"></i>
                                                                </button>
                                                                {write &&
                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                        <li className="py-1"><a onClick={(e) => {setUpDrawer(obj3.unique_id);}} data-bs-toggle="modal" data-bs-target="#EditModal" style={{cursor:"pointer"}} className={`dropdown-item`} >View details</a></li>
                                                                        {(User_role=="Admin" && (obj3.log_status!=="voucher_creation" || obj3.log_status!=="cancelled"))&&
                                                                        <li className="py-1"><a onClick={(e) => { updateStatus(obj3.unique_id);}} style={{cursor:"pointer"}} className={`dropdown-item`}>Cancel</a></li>}
                                                                        {obj3.log_status==="DRAFT" &&
                                                                            <>
                                                                            {obj3.collection_entry_flag==="dealer-collection-entry" ?
                                                                            <li className="py-1"><a href={`/edit-dealer-collection-entry/${obj3.unique_id}`} className={`dropdown-item`}>Edit Details</a></li>
                                                                            :
                                                                            <li className="py-1"><a href={`/edit-dealer-pdc-collection-entry/${obj3.unique_id}`} className={`dropdown-item`}>Edit Details</a></li>
                                                                            }
                                                                            </>
                                                                        }   
                                                                    </ul>
                                                                }
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </>
                                                )
                                            })
                                        }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                state==2 ?
                                <>
                                    <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                </>
                                :
                                state==4 &&
                                <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                    <div className="d-flex flex-stack flex-grow-1">
                                        <div className="fw-bold">
                                            <h4 className="text-gray-800 fw-bolder">No Data Available.</h4>
                                            <div className="fs-6 text-gray-600"> </div>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={DenominationModalShow} onHide={() => { setDenominationModalShow(false) }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Denominations</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setDenominationModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container' style={{ overflowY: "scroll", height: "25rem" }}>
                    {FinalamtArray.length > 0 &&
                        <table className="table table-row-dashed align-middle gs-0 gy-4 my-0">
                            <thead>
                                <tr className="fs-7 fw-bold text-gray-500 border-bottom-0">
                                    <th className="p-0 pb-3 min-w-100px text-start">AMOUNT</th>
                                    <th className="pe-0 text-end min-w-100px">QTY</th>
                                    <th className="pe-0 text-end min-w-100px">TOTAL PRICE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {FinalamtArray.map((obj4, indx4) => {
                                    return (
                                        <>
                                            <tr>
                                                <td>
                                                    <span className="text-gray-800 fw-bold d-block fs-6">{CurrencySymbol} {obj4.category}</span>
                                                </td>
                                                <td>
                                                    <span className="text-gray-800 fw-bold d-block fs-6 ps-0 text-end">x{obj4.count}</span>
                                                </td>
                                                <td className="text-end pe-0">
                                                    <span className="text-gray-800 fw-bold d-block fs-6">{CurrencySymbol} {obj4.amount}</span>
                                                </td>
                                            </tr>
                                        </>
                                    )
                                })
                                }
                                <tr>
                                    <td colspan="2" className="text-end">
                                        Subtotal
                                    </td>
                                    <td className="text-end">
                                        {CurrencySymbol}{Math.round(FinalamtArray.reduce((p, o) => { return p + (Math.round((o.amount) * 100) / 100) }, 0) * 100) / 100}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setDenominationModalShow(false); }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={StatusModalShow} onHide={()=>{setStatusModalShow()}} size="md" centered>
				<Modal.Header>
					<Modal.Title>Change Status</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={()=>{setStatusModalShow(false)}}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
                        <div className="col-lg-12">
                            Current Status is : {status==="PENDING_APPROVAL" ?
                                <span className="badge badge-light-warning">Pending</span>
                                :
                                status==="DRAFT" ?
                                <span className="badge badge-secondary">Draft</span>
                                :
                                <span className="badge badge-success">{status}</span>
                            }<br/> 
                            <h3>Are you sure about cancelling collection details?</h3>
                        </div>
					</div>
				</Modal.Body>
				<Modal.Footer> 
					{/* <button type="button" onClick={(e) => {setStatusModalShow(false)}} className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button> */}
					{write==1 &&<form >
						<button type="button" onClick={(e) => { submitStatus(e) }} className="btn btn-danger"  data-kt-indicator={mainSubmitButtonState?"on":"off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
						<span className="indicator-progress">Please wait...
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
					</form>}
				</Modal.Footer>
			</Modal>

            <Drawer title={Dealer_name} width={window.innerWidth > 1200 ? 800 : 'auto'} bodyStyle={{ padding: "1.5rem" }} onClose={onClose} open={open} closeIcon={<a onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"/><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z"/><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z"/></svg>
            </a>}
                extra={
                    <Space>
                         {/* <Button onClick={onClose} type="primary">Close</Button> */}
                        <div className="dropdown">
                            <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fas fa-bars px-0"></i>
                            </button>
                            {(Collection_details != null && write) &&
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {(User_role=="Admin" && (Collection_details.log_status!=="voucher_creation" || Collection_details.log_status!=="cancelled"))&&
                                    <li className="py-1"><a onClick={(e) => { updateStatus(Collection_details.unique_id);}} className={`dropdown-item`}>Cancel</a></li>}
                                    {Collection_details.log_status==="DRAFT" &&
                                        <>
                                        {Collection_details.collection_entry_flag==="dealer-collection-entry" ?
                                        <li className="py-1"><a href={`/edit-dealer-collection-entry/${Collection_details.unique_id}`} className={`dropdown-item`}>Edit Details</a></li>
                                        :
                                        <li className="py-1"><a href={`/edit-dealer-pdc-collection-entry/${Collection_details.unique_id}`} className={`dropdown-item`}>Edit Details</a></li>
                                        }
                                        </>
                                    }   
                                </ul>
                            }
                        </div>
                    </Space>
                }

            >
                <div className="card">
                    <div className="d-flex w-100 overflow-auto">
                        <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                            <li className="nav-item mx-lg-1">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Transactions" && "active"}`} onClick={(e) => { setnavtype("Transactions"); }}>Transaction</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="card">
                    {navtype === "Overview" ?
                        <>
                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                <div className="card-title m-0">
                                    <h3 className="fw-bold m-0">Overview</h3>
                                </div>
                                {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                            </div>
                            {Collection_details != null &&
                                <div className="card-body p-9">
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Id</label>
                                        <div className="col-lg-8">
                                            <span className="fw-bold fs-6 text-gray-800">{Collection_details.dcr_number!=undefined?<>{Collection_details.dcr_number}</>:<>{Collection_details.pdcr_number}</>}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Type</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Collection_details.dcr_number!=undefined?
                                                <span className="badge badge-light-primary">DCR</span>
                                                :
                                                <span className="badge badge-light-primary">PDCR</span>
                                            }</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Payment Mode</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="badge badge-light-primary">{Collection_details.payment_mode}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Date</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Collection_details.dcr_date!=undefined?<>{moment(Collection_details.dcr_date).format("ll")}</>:<>{moment(Collection_details.pdcr_date).format("ll")}</>}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Branch</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Collection_details.branch_name}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Dealer Name</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Collection_details.dealer_display_name}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">DSO User</label>
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{Collection_details.dso_name}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Status
                                        </label>
                                        <div className="col-lg-8 d-flex align-items-center">
                                            {Collection_details.log_status==="PENDING_APPROVAL" ?
                                                <span className="badge badge-light-warning">Pending</span>
                                                :
                                                Collection_details.log_status==="DRAFT" ?
                                                <span className="badge badge-secondary">Draft</span>
                                                :
                                                Collection_details.log_status==="DRAFT" ?
                                                <span className="badge badge-secondary">Draft</span>
                                                :
                                                Collection_details.log_status==="cancelled" ?
                                                <span className="badge badge-danger">Cancelled</span>
                                                :
                                                <span className="badge badge-success">{Collection_details.log_status}</span>
                                            }  
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Billing Address</label>
                                        {Collection_details.billing_address!==null &&
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{`${Collection_details.billing_address.state && Collection_details.billing_address.state},${Collection_details.billing_address.city}, ${Collection_details.billing_address.pincode},${Collection_details.billing_address.country}`}</span>
                                        </div>}
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Shipping Address</label>
                                        {Collection_details.shipping_address!==null &&
                                        <div className="col-lg-8 fv-row">
                                            <span className="fw-semibold text-gray-800 fs-6">{`${Collection_details.shipping_address.state!=undefined && Collection_details.shipping_address.state},${Collection_details.shipping_address.city}, ${Collection_details.shipping_address.pincode}, ${Collection_details.shipping_address.country}`}</span>
                                        </div>}
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Tax Detils</label>
                                        <div className="col-lg-8 fv-row">
                                        {Collection_details.gstin_details!=null &&<span className="fw-semibold text-gray-800 fs-6">{`${Collection_details.gstin_details.GstIn},${Collection_details.gstin_details.gst_treatment}`}</span>}
                                        </div>
                                        {/* <div className="col-lg-8 d-flex flex-wrap align-items-center gap-1">
                                        <>
                                            <div className="border border-gray-300 border-dashed rounded min-w-100px py-2 px-4 mx-3">
                                                <span className="fs-6 text-gray-700 fw-bold">{Collection_details.gstin_details.gst_treatment}</span>
                                                <div className="fw-semibold text-gray-400">GST Treatment</div>
                                            </div>
                                            <div className="border border-gray-300 border-dashed rounded min-w-100px py-2 px-4 mx-3">
                                                <span className="fs-6 text-gray-700 fw-bold">{Collection_details.gstin_details.GstIn}</span>
                                                <div className="fw-semibold text-gray-400">GSTIN</div>
                                            </div>
                                        </>
                                        </div> */}
                                    </div>        
                                    <div className="row mb-3">
                                        <label className="col-lg-4 fw-semibold text-muted">Remarks</label>
                                        <div className="col-lg-8">
                                            <span className="fw-semibold fs-6 text-gray-800">{Collection_details.remarks}</span>
                                        </div>
                                    </div>  
                                </div>
                            }
                        </>
                        :
                        navtype === "Transactions" ?
                            <>
                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                <div className="card-title m-0">
                                    <h3 className="fw-bold m-0">Transaction Details</h3>
                                </div>
                                {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                            </div>
                            {Collection_details != undefined &&
                                <div className="card-body p-9">
                                    <div className="table-responsive">
                                        <table className="table align-middle">
                                            <tbody>
                                            {
                                                Collection_details.payment_details.map((obj3, indx3) => {
                                                    return (
                                                    obj3.payment_info.length>0 &&
                                                        <>                     
                                                        <tr>
                                                            <td className="bg-light rounded text-gray-600 fs-8 fw-bold px-3 py-2" colspan="4">
                                                            {obj3.payment_method}</td>
                                                        </tr>
                                                        {
                                                            obj3.payment_info.map((obj4, indx4) => {
                                                            return (
                                                                <>
                                                                {obj3.payment_method=="Cash" ?                           
                                                                <tr>
                                                                    {/* <td className="fs-6 fw-bold text-gray-800">
                                                                        {obj4.brand_name}</td> */}
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Brand:
                                                                        <span className="text-gray-800"> {Collection_details.brand_list.filter(option => option.brand_id ==obj4.brand_id)[0].brand_name}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">
                                                                            Amount:
                                                                            <span className="text-gray-800"> {CurrencySymbol} {obj4.amount}</span>                                                         
                                                                    </td>
                                                                    <td className="pe-0 text-end">
                                                                        <button onClick={() => { Set_Denomination(obj3.Denomination); }} className="btn btn-sm btn-light">
                                                                            Denomination
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                :
                                                                obj3.payment_method=="Cheque" ?  
                                                                <tr>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Brand:
                                                                        <span className="text-gray-800"> {obj4.brand_name}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Cheque no:
                                                                        <span className="text-gray-800"> {obj4.cheque_no}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Cheque Date:
                                                                        <span className="text-gray-800"> {moment(obj4.cheque_date).format("ll")}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Amount:
                                                                        <span className="text-gray-800"> {CurrencySymbol} {obj4.amount}</span>  
                                                                    </td>
                                                                </tr>
                                                                :
                                                                obj3.payment_method=="Bank Transaction" &&
                                                                <>  
                                                                <tr>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Brand:
                                                                        <span className="text-gray-800"> {obj4.brand_name}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Date:
                                                                        <span className="text-gray-800"> {moment(obj4.transaction_date).format("ll")}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">
                                                                        Transaction Id:
                                                                            <span className="text-gray-800"> {obj4.transaction_reference_id}</span>                                                         
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Bank:
                                                                        <span className="text-gray-800"> {obj4.bank_name}</span>  
                                                                    </td>
                                                                    <td className="fs-6 fw-bold text-gray-400">                                         
                                                                        Amount:
                                                                        <span className="text-gray-800"> {CurrencySymbol} {obj4.amount}</span>  
                                                                    </td>
                                                                </tr>
                                                                </>    
                                                                }
                                                                </>
                                                                )
                                                            })
                                                        }
                                                        </>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            }
                            </>
                            :
                            navtype === "History" &&
                            <>
                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                <div className="card-title m-0">
                                {Collection_details != undefined &&
                                    <h3 className="fw-bold m-0">{Collection_details.dcr_number!=undefined?<>{Collection_details.dcr_number}</>:<>{Collection_details.pdcr_number}</>}</h3>
                                }
                                </div>
                                {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                            </div>
                            {Collection_details != undefined &&
                                <div className="card-body p-9">
                                    {Collection_history_details.length>0 && Collection_history_details.map((obj, index) => {
                                        return (
                                            <>
                                            <div className="m-0">
                                                <div className="d-flex align-items-sm-center mb-5">
                                                    {/* <div className="timeline-icon symbol symbol-circle symbol-40px">
                                                        <div className="symbol-label bg-light">
                                                            <span className="svg-icon svg-icon-2 svg-icon-gray-500"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z" fill="currentColor"></path>
                                                            <path d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z" fill="currentColor"></path>
                                                            </svg>
                                                            </span>
                                                        </div>
                                                    </div> */}
                                                    <div className="d-flex align-items-center flex-row-fluid flex-wrap">                    
                                                        <div className="flex-grow-1 me-2">
                                                        {obj.operation === "insert" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Created</span>:obj.operation === "cancelled" ? <span className="badge badge-lg badge-danger fw-bold my-2">Cancelled</span>:obj.operation === "voucher_creation" ?<><span className="badge badge-lg badge-success fw-bold my-2">Voucher Created</span><a href={`/dealer-master-voucher-summary/${obj.master_voucher_id}`} className="text-primary fw-bold me-1"> #{obj.master_voucher_name}</a></>:<span className="badge badge-lg badge-primary fw-bold my-2">Updated</span>}
                                                            {/* <span className="text-gray-800 fw-bold d-block fs-4">{obj.operation === "voucher_creation" &&<>#<a href="#" className="text-primary fw-bold me-1">#{OBJ.MASTER_VOUCHER_NAME}</a></>}</span> */}
                                                        </div>                     
                                                        
                                                        {/* <span className="badge badge-lg badge-light-success fw-bold my-2">Delivered</span> */}
                                                    </div>               
                                                </div>
                                                <div className="timeline">                                 
                                                    <div className="timeline-item align-items-center mb-7">
                                                        <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                            <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                            <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                            </svg>
                                                        </span>
                                                        <div className="timeline-content m-0">
                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                            <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>   
                                                        </div>                                 
                                                    </div>
                                                    <div className="timeline-item align-items-center">
                                                        <div className="timeline-line w-40px"></div>
                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                            <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                            <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                            </svg>
                                                        </span>
                                                        <div className="timeline-content m-0">
                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                            <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                                        </div>                                
                                                    </div>                                        
                                                </div>
                                            </div>
                                            {Collection_history_details.length>1 &&
                                                <div className="separator separator-dashed my-6"></div>
                                            }
                                            </>
                                        )
                                    })}
                                </div>
                            }
                        </>
                    }
                </div>
            </Drawer>

            <Organization_modal OrganizationModalShow={OrganizationModalShow} setOrganizationModalShow1={setOrganizationModalShow} organization_name={organization_name} organization_list={organization_list} organization_id={organization_id} state_org={state_org} />
            <Timer_modal clockTimerModalShow={clockTimerModalShow} setClockTimerModalShow1={setClockTimerModalShow} clock_timer={clock_timer} organization_id={organization_id} timer_ref={timer} />
        </>
    );
}
export default DealerCollectionList;